import type { Vec2 } from './vec';

/**
 * Ultra Hammy's END THEM minions (spec 2026-09-29): three tier-2 Ultra Hammies
 * who stand across the top of the screen for the length of the boost, throwing
 * dynamite at any enemy on the map.
 *
 * They are deliberately NOT towers. Everything in `GameSim.towers` is a stun
 * and hex candidate, a fireball target, selectable by its plot, sellable,
 * upgradable, counted by the one-at-a-time cap and greased by a Goddess — and
 * the brief rules every one of those out for them. So they live in their own
 * list, and their dynamite is an ordinary projectile that never passes through
 * `effectiveSpec`: the flat 300 is the flat 300.
 */
export interface MinionState {
  id: number;
  /** Where he stands (and throws from). */
  pos: Vec2;
  /** Seconds until his next throw; 0 = ready and waiting for a target. */
  cooldown: number;
}

/**
 * Where the minions stand, left to right: spread across the top of the 1280 ×
 * 720 board, clear of the HUD's top-left readouts and its top-right buttons.
 * Only the first `count` are used.
 */
export const MINION_POSITIONS: readonly Vec2[] = [
  { x: 440, y: 84 },
  { x: 640, y: 84 },
  { x: 840, y: 84 },
];
